import React, { useEffect, useState } from "react";
import "../UserDetails/UserDetails.scss";
import BackArrow from "../../../assets/images/vactor/back-arrow.svg";
import ActivitiesBookIcon from "../../../assets/images/vactor/activitie-books.svg";
import UserDp from "../../../assets/images/banner/test-user.jpg";
import { resolveAssetUrl } from "../../../Utils/url";
import { Slider } from "@mui/material";
import {
  LightButton,
  PrimaryButton,
} from "../../../components/AllButtons/AllButtons";
import QuizPerformanceTable from "../../../components/AdminComponents/QuizPerformanceTable/QuizPerformanceTable";
import DeleteCommonDialog from "../../../components/DeleteCommonDialog/DeleteCommonDialog";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../Store/store";
import { getQuizPerformance, viewUser } from "../../../Services/admin.service";

const UserDetails = () => {
  const [deletedialog, setDeletedialog] = React.useState(false);
  const [quizPerformance, setQuizPerformance] = useState<any>();
  const userQuizPerformance = useAppSelector(state => state.admin.userQuizData) ?? [];
  const firstTwoLessons = userQuizPerformance.slice(0, 2);
  const dispatch = useAppDispatch();

  const handleOpen = () => setDeletedialog(true);
  const handleClose = () => setDeletedialog(false);

  const handleDelete = () => {
    setDeletedialog(false);
    // Add actual delete logic here
  };

  const userDetails = useAppSelector(state => state.admin.selectedUserData);
  const quizPerformancelist = useAppSelector(state => state.admin.userQuizData)??[];

  useEffect(()=>{
    dispatch(viewUser(localStorage.getItem('email')));
  },[])

  useEffect(() => {
    if (userDetails && userDetails.id) {
      dispatch(getQuizPerformance(userDetails.id))
        .catch(error => console.error(error));
    }
  }, [dispatch, userDetails]);

  function formatDate(dateString: any) {
    const date = new Date(dateString);
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  }

  function timeSince(dateString: string): string {
    const now = new Date();
    const past = new Date(dateString);
    const seconds = Math.floor((now.getTime() - past.getTime()) / 1000);
    if (seconds < 60) return `${seconds} seconds ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    const days = Math.floor(hours / 24);
    if (days < 30) return `${days} day${days > 1 ? 's' : ''} ago`;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} month${months > 1 ? 's' : ''} ago`;
    const years = Math.floor(months / 12);
    return `${years} year${years > 1 ? 's' : ''} ago`;
  }

  const apiDate = userDetails?.created_at;
  const formattedDate = formatDate(apiDate);

  return (
    <>
      <div className="admin-content-wrapper">
        <div className="admin-content-subheader">
          <div className="admin-content-subheader-title">
            <Link to="/admin/user_management">
              <img src={BackArrow} alt="" />
            </Link>{" "}
            User Details
          </div>
        </div>

        <div className="row gy-4">
          <div className="col-md-5">
            <div className="common-card-wrap user-details-card-wrap">
              <div className="user-dp-block">
                <div className="user-dp-img">
                  <img src={userDetails?.profile_image!==null ? resolveAssetUrl(userDetails?.profile_image) :UserDp} alt="" />
                </div>
                <div className="user-dp-name">{userDetails?.name}</div>
                <div className="user-dp-email">{userDetails?.email}</div>
              </div>
              <div className="grade-block">
                <div className="grade-label">Grade</div>
                <div className="grade-value">{userDetails?.grade}th Grade</div>
              </div>
              <div className="remaining-slider-block">
                <div className="remaining-tokens-block">
                  <div className="tokens-label">Tokens</div>
                  <div className="tokens-value">
                    {userDetails?.remaining_tokens}
                  </div>
                </div>
                {/* <div className="remaining-slider">
                  <Slider
                    defaultValue={50}
                    aria-label="Default"
                    valueLabelDisplay="auto"
                  />
                </div> */}
              </div>
              <div className="active-limit-block">
                <div className="active-label">Active Subscription</div>
                <div className="limite-tokens">Limited Token</div>
              </div>
              <div className="join-date">Joined: {formattedDate}</div>
              {/* <div className="user-details-card-footer">
                <PrimaryButton onClick={handleOpen}>Delete</PrimaryButton>
                <LightButton>Back</LightButton>
              </div> */}
            </div>
          </div>

          <div className="col-md-7">
            <div className="custom-user-activites-goups">
              <div className="common-card-wrap custom-user-activites-card">
                <div className="custom-user-activites-card-titles">
                  Time Spent on Platform
                </div>
                <div className="time-spent-block">
                  <div className="total-time">
                    <h4 className="time-spent-value">{userDetails?.total_time_since_signup}</h4>
                    <div className="time-spent-label">Total Time</div>
                  </div>
                  <div className="today-time">
                    <h4 className="time-spent-value">{userDetails?.total_time_today}</h4>
                    <div className="time-spent-label">Today</div>
                  </div>
                </div>
              </div>

              <div className="common-card-wrap custom-user-activites-card">
                <div className="custom-user-activites-card-titles">
                  Recent Activity
                </div>
                <div className="recent-activity-block">
                  <div className="recent-activity-items">
                    <div className="activity-items-icon">
                      <img src={ActivitiesBookIcon} alt="" />
                    </div>
                    <div className="activity-items-content">
                      <div className="activity-items-name">
                        Completed Chapter: {firstTwoLessons && firstTwoLessons.length >= 2
                          ? firstTwoLessons[0].lesson_name
                          : "No Recent Activity"}
                      </div>
                      <div className="activity-items-times">
                        {firstTwoLessons && firstTwoLessons.length >= 2
                          ? timeSince(firstTwoLessons[0]?.answered_at)
                          : "not given"}
                      </div>
                    </div>
                  </div>

                  <div className="recent-activity-items">
                    <div className="activity-items-icon">
                      <img src={ActivitiesBookIcon} alt="" />
                    </div>
                    <div className="activity-items-content">
                      <div className="activity-items-name">
                        Completed Chapter: {firstTwoLessons && firstTwoLessons.length >= 2
                          ? firstTwoLessons[1].lesson_name
                          : "No Recent Activity"}
                      </div>
                      <div className="activity-items-times">
                        {firstTwoLessons && firstTwoLessons.length >= 2
                          ? timeSince(firstTwoLessons[1]?.answered_at)
                          : "not given"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {quizPerformancelist?.length>0 && (  
            <div className="col-md-12">
              <div className="custom-user-activites-goups">
                <div className="common-card-wrap custom-user-activites-card">
                  <div className="custom-user-activites-card-titles">
                    Quiz Performance
                  </div>
                  <div>
                    <QuizPerformanceTable quizPerformance={quizPerformancelist}/>
                  </div>
                </div>
              </div>
            </div>)}        
        </div>
      </div>

      {/* user details delete popup  */}
      <DeleteCommonDialog onClose={handleClose} isDeleteOpen={deletedialog} />
    </>
  );
};

export default UserDetails;
